<template>
    <div>
        <div class="registration-section__form-group-title">
            {{ $t('Rules of the game. And of course the way we protect and proccess your data') }}
            <div>
                <i18n path="registration.intro">
                    <StaticLink
                        place="terms"
                        path="terms-and-conditions"
                        target="_blank"
                        class="action-text"
                    >
                        {{ $t('Superbet terms and conditions') | capitalize }}
                    </StaticLink>
                    <StaticLink
                        place="statement"
                        path="declaratia-de-confidentialitate"
                        target="_blank"
                        class="action-text"
                    >
                        {{ $t('Superbet Confidentiality Statement') }}
                    </StaticLink>
                </i18n>
            </div>
        </div>
        <div class="privacy__form">
            <div class="form-group">
                <CustomCheckbox
                    name="termsAgree"
                    :value="termsAgree"
                    label=""
                    :errorMessage="errors.termsAgree"
                    @input="$emit('update:termsAgree', $event)"
                    @valueChanged="$listeners.valueChanged"
                >
                    <TermsAndConditions/>
                </CustomCheckbox>
            </div>
            <div class="form-group">
                <CustomCheckbox
                    name="customMarketingConsent"
                    :value="customMarketingConsent"
                    label=""
                    :errorMessage="errors.customMarketingConsent"
                    @input="$emit('update:customMarketingConsent', $event)"
                    @valueChanged="$listeners.valueChanged"
                >
                    <PrivacyConsentGeneralInfo/>
                </CustomCheckbox>
            </div>
            <div v-if="customMarketingConsent"
                 class="registration-section__form-group-title"
            >
                {{ $t('customMarketingConsent.intro') }}:
            </div>
            <div
                v-if="customMarketingConsent"
                class="form-group"
            >
                <CustomCheckbox
                    name="receiveOperatorEmailConsent"
                    :value="receiveOperatorEmailConsent"
                    label=""
                    :errorMessage="errors.receiveOperatorEmailConsent"
                    @input="$emit('update:receiveOperatorEmailConsent', $event)"
                    @valueChanged="$listeners.valueChanged"
                >
                    <div class="privacy-general__info">
                        {{ $t('E-mail') }}
                    </div>
                </CustomCheckbox>
            </div>
            <div
                v-if="customMarketingConsent"
                class="form-group"
            >
                <CustomCheckbox
                    name="receiveOperatorSMSConsent"
                    :value="receiveOperatorSMSConsent"
                    label=""
                    :errorMessage="errors.receiveOperatorSMSConsent"
                    @input="$emit('update:receiveOperatorSMSConsent', $event)"
                    @valueChanged="$listeners.valueChanged"
                >
                    <div class="privacy-general__info">
                        {{ $t('SMS') }}
                    </div>
                </CustomCheckbox>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            termsAgree: {
                type: Boolean,
                required: true,
            },
            customMarketingConsent: {
                type: Boolean,
                required: true,
            },
            receiveOperatorEmailConsent: {
                type: Boolean,
                required: true,
            },
            receiveOperatorSMSConsent: {
                type: Boolean,
                required: true,
            },
            errors: {
                type: Object,
                required: true,
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/authentication/components/register/TermsAndConditions.vue